import { atom, useSetAtom } from "jotai";

interface Org {
    orgID: string;
    name: string;
    created: string;
    modified: string; 
    type: string; 
    description: string | null;
    photoURL: string | null;
    website: string | null;
    isTwoFactorRequired: boolean;
    enableASRTranscription: boolean;
    enableHumanTranscription: boolean;
    invitationsExpireIn: number | null;
    defaultProduct: string;
    minimalProductStatus: string; 
    canUserPurchaseLicense: boolean;
    licenseType: string; 
    deleted: boolean;
}

interface Group {
    groupID: string;
    name: string;
    visibility: any; 
    groupType: string;
}

interface HierarchyNode {
    parentID: string;
    childID: string;
    hierarchyID: number;
    group: Group;
    children?: HierarchyNode[];
}

export interface BASEStateInterface {
    selectedOrg: Org;
    selectedGroup:HierarchyNode;
    selectedCohort:HierarchyNode;
    deleteGroupDataInfo:HierarchyNode;
    addCohortModalOpen: boolean;
    addTeamModalOpen: boolean;
    addFolderModalOpen: boolean;
    deleteGroupConfrimModalOpen:boolean;
}

export const INITIAL_S_ADMIN_IN_ATOM_VALUE : BASEStateInterface = {
    selectedOrg : {
        orgID: "",
        name: "",
        created: "",
        modified: "",
        type: "",
        description: "",
        photoURL: "",
        website: "",
        isTwoFactorRequired: false,
        enableASRTranscription: false,
        enableHumanTranscription: false,
        invitationsExpireIn: 0,
        defaultProduct: "",
        minimalProductStatus: "",
        canUserPurchaseLicense: false,
        licenseType: "",
        deleted: false
    },
    selectedGroup:{
        parentID: "",
        childID: "",
        hierarchyID: -1,
        group: {
            groupID: "",
            name: "",
            visibility: "",
            groupType: "",
        },
    },
    selectedCohort:{
        parentID: "",
        childID: "",
        hierarchyID: -1,
        group: {
            groupID: "",
            name: "",
            visibility: "",
            groupType: "",
        },
        children: [],
    },
    deleteGroupDataInfo:{
        parentID: "",
        childID: "",
        hierarchyID: -1,
        group: {
            groupID: "",
            name: "",
            visibility: "",
            groupType: "",
        },
        children: [],
    },
    addCohortModalOpen: false,
    addTeamModalOpen: false,
    addFolderModalOpen: false,
    deleteGroupConfrimModalOpen:false,
};

export const SAdminBaseAtom = atom<BASEStateInterface>(INITIAL_S_ADMIN_IN_ATOM_VALUE);